import { Alert, Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorTokens } from '../../../../shared/components/variables';

export const Container = styled.div<{ stacked?: boolean }>`
  display: flex;
  padding: 6px 20px;
  width: 100%;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 10px;
  min-height: 54px;
  align-self: stretch;

  color: ${colorTokens.border.dark};
`;

export const StackedAlertContainer = styled(Box)`
  display: flex;
  padding: 6px 0;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
`;

export const StackedStyledAlert = styled(Alert)<{ showSeverity: boolean }>`
  display: flex;
  padding: 3px 8px;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid var(--error-main, #cf1c00);
  background: rgba(255, 216, 210, 0.6);
  height: 40px;

  .MuiAlert-icon {
    display: ${({ showSeverity }) => (showSeverity ? 'block' : 'none')};
    margin-right: 0;
  }

  .MuiAlert-message {
    width: 100%;
  }
`;

export const StyledAlert = styled(Alert)`
  padding: 2px 8px;
  width: 100%;
  text-wrap: nowrap;

  /* &.MuiAlert-standardWarning {
    border: 1px solid ${colorTokens.warning.dark};
  }

  &.MuiAlert-standardError {
    border: 1px solid ${colorTokens.error.dark};
  } */

  .MuiAlert-icon {
    margin-top: 0;
    margin-bottom: 0;
  }

  .MuiTypography-root {
    margin-top: 0;
    margin-bottom: 0;
  }

  .MuiAlert-message {
    display: flex;
    padding: 0;
    flex-direction: row;
    align-items: center;
    gap: 64px;
    width: 100%;
  }
`;

export const AlertMessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    max-height: 32px;
  }
`;

export const StackedAlertMessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
